import { Component, For } from 'solid-js';

interface ErrorType {
  error: { [key: string]: string[] } | string[] | null | undefined | string;
  showHelpertext: boolean;
}

const ForComponent: Component<{
  errors: string[];
  showHelpertext: boolean;
}> = (props) => {
  return (
    <For each={props.errors}>
      {(err) => (
        <p class="mx-[14px]! mt-[3px] text-[0.75rem] text-[#d32f2f]!">
          {props.showHelpertext && err}
        </p>
      )}
    </For>
  );
};

const FormErrorComponent: Component<ErrorType> = (props: ErrorType) => {
  return (
    <>
      {Array.isArray(props.error) && (
        <ForComponent
          errors={props.error}
          showHelpertext={props.showHelpertext}
        />
      )}
      {!Array.isArray(props.error) &&
        typeof props.error === 'object' &&
        props.error !== null && (
          <>
            {Object.keys(props.error).map((key) => (
              <ForComponent
                errors={(props.error as Record<string, string[]>)[key]}
                showHelpertext={props.showHelpertext}
              />
            ))}
          </>
        )}
    </>
  );
};

export default FormErrorComponent;
